<template>
    <div class="loader" v-if="isLoading">
        <div class="loader-circles">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <p class="mt-3">We are downloading profile, it will take a couple of minutes. Please wait :)</p>
    </div>
</template>
<script>

export default {
    name: "Loader",
    data() {
        return {
            isLoading: false,
        }
    },

    created() {
        this.$root.$on('loader-state-change', (state) => {
            this.isLoading = state
        })
    },
}
</script>
